export const getDisscount = (unit_price, disscount) => {
	const operation = unit_price - unit_price * (disscount / 100);
	return operation;
};
